import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { LoadingController } from 'ionic-angular';

/*
  Generated class for the SloaderProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class Sloader {
    public url: string;
    public params: any;
    public limit: number;
    public method: string = 'post';
    public timeout: number = 5000;
    loader: any = null;
    isLoading: boolean = false;
    showLoading: boolean = true;
    private current: number;

    constructor(
        public http: HttpClient,
        public loadingController: LoadingController,
        //public network: Network
    ) {
        console.log('Init loader');
        //console.log(this.network.type);
    }

    next(): any {
        // if (this.network.type == 'none' || !this.is_next) {
        //     let observable = new Observable(observer => {
        //         observer.next({'data': []});
        //     });
        //     return observable;
        // }

        if (this.method == 'get') {
            return this.get();
        } else {

            return this.load();
        }


    }

    init(url: string, params: any) {
        this.url = url;
        this.params = params;
        if (null == this.params.limit) {
            this.params.limit = 15;
        }
        if (null == this.params.offset) {
            this.params.offset = 0;
        }
        this.current = 1;
        if (params['method']) {
            this.method = params['method'];
        }
        if ('showLoading' in params) {
            this.showLoading = params['showLoading'];
        } else {
            this.showLoading = true;
        }

    }

    load() {
        this._prepareParams();
        let loader: any;
        if (this.current == 1) {
            loader = this._setLoader();
        }
        return this.http.post(this.url, this.params).pipe(
            tap(res => {
                if (this.current == 1) {
                    this._hideLoader(loader);
                }
                if (res['err_code'] === '') {

                    if (res['data'].length > 0) {
                        this._increaseCurrent();
                    } else {
                        this._loadAll();
                    }
                }
            }),
            catchError(e => {
                throw e;
            })
        );
    }

    get() {
        this._prepareParams();
        return this.http.get(this.url, this.params).pipe(
            tap(res => {
                if (res['err_code'] === '') {
                    if (res['data'].length > 0) {
                        this._increaseCurrent();
                    } else {
                        this._loadAll();
                    }
                }
            }),
            catchError(e => {
                throw e;
            })
        );
    }

    pull(): any {
        let p = { ...this.params };
        p.offset = 0;
        return this.http.post(this.url, p).pipe(
            tap(res => {
                return res['data'];
            }),
            catchError(e => {
                throw e;
            })
        );
    }

    private _setLoader() {
        if (this.isLoading == false && this.showLoading) {
            let loader = this.loadingController.create({
                content: ''
            });
            loader.present();
            this.isLoading = true;
            return loader;
        }
        return null;
    }

    private _hideLoader(loader) {
        if (loader != null) {
            loader.dismiss();

        }
        this.isLoading = false;
    }

    private _prepareParams(): void {
        this.params.offset = (this.current - 1) * this.params.limit;
    }

    private _loadAll(): void {
    }

    private _increaseCurrent() {
        this.current += 1;
    }

}



// WEBPACK FOOTER //
// ./src/providers/common/sloader.ts